import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Badge, InteractionLayer, Typography } from "@bookips/sds";
import Image from "next/image";
import Link from "next/link";
// 아이템 총 너비(개수 × 110px)에 맞춰 정확한 breakpoint에서 가운데 정렬
// 이렇게까지 할일인가 싶었지만, 동적인 렌더인 상황에서 갯수가 적거나 많았을때 정렬대응이 쉽지 않아 처리합니다.
// 복잡하지 않은 방법으로 선택했으나, 추후 컴포넌트 리팩토링 시 고려해보기
//  26.02.02 @summer
const JUSTIFY_BREAKPOINT_MAP = {
    5: "min-[550px]:justify-center",
    6: "min-[660px]:justify-center",
    7: "min-[770px]:justify-center",
    8: "min-[880px]:justify-center",
    9: "min-[990px]:justify-center",
    10: "min-[1100px]:justify-center"
};
const QuickMenu = (param)=>{
    let { items , homeId , className  } = param;
    const count = (items === null || items === void 0 ? void 0 : items.length) || 0;
    const justifyClass = JUSTIFY_BREAKPOINT_MAP[count] || "min-[1320px]:justify-center";
    return /*#__PURE__*/ _jsx("div", {
        className: cn("w-full pb-6 max-sm:px-5 sm:pb-10", className),
        children: /*#__PURE__*/ _jsx("div", {
            className: "scrollbar-hide w-full overflow-x-auto",
            children: /*#__PURE__*/ _jsx("div", {
                className: cn("mx-auto flex w-full max-w-[1200px]", justifyClass, "max-sm:grid max-sm:w-full max-sm:grid-cols-4 max-sm:justify-start max-sm:justify-items-center max-sm:px-0"),
                children: items === null || items === void 0 ? void 0 : items.map((item, index)=>/*#__PURE__*/ _jsx(QuickMenuButton, {
                        item: item,
                        index: index,
                        homeId: homeId
                    }, item.id))
            })
        })
    });
};
const QuickMenuButton = (param)=>{
    let { item , index , homeId  } = param;
    // MX-372: 퀵메뉴 클릭 트래킹
    const handleClick = ()=>{
        var _item_subTitle, _item_badgeText;
        mixpanelEvent("[Home] Quick Menu Clicked", {
            "Home Id": homeId !== null && homeId !== void 0 ? homeId : "",
            Title: item.title,
            "Sub Title": (_item_subTitle = item.subTitle) !== null && _item_subTitle !== void 0 ? _item_subTitle : "",
            Tag: (_item_badgeText = item.badgeText) !== null && _item_badgeText !== void 0 ? _item_badgeText : "",
            Seq: index + 1
        });
    };
    return /*#__PURE__*/ _jsxs(InteractionLayer, {
        as: Link,
        href: item.link,
        onClick: handleClick,
        variant: "light",
        className: cn("relative flex w-[110px] shrink-0 flex-col items-center gap-3 py-4", "rounded-lg", "max-sm:w-[80px] max-sm:gap-2 max-sm:py-3"),
        children: [
            item.badgeText && /*#__PURE__*/ _jsx("div", {
                className: "absolute top-0 z-2",
                children: /*#__PURE__*/ _jsx(Badge, {
                    color: "red",
                    label: item.badgeText,
                    type: "text",
                    className: "shrink-0 px-1.5 max-sm:text-[10px]"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn("relative h-14 w-14 overflow-hidden rounded-lg border border-gray-200/20", "max-sm:h-12 max-sm:w-12", !item.imageUrl && "bg-gray-50"),
                children: item.imageUrl && /*#__PURE__*/ _jsx(Image, {
                    src: item.imageUrl,
                    alt: item.title,
                    fill: true,
                    className: "object-cover"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full flex-col items-center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle2",
                        className: "text-strong max-sm:typo-label w-full truncate text-center",
                        children: item.title
                    }),
                    item.subTitle && /*#__PURE__*/ _jsx(Typography, {
                        variant: "caption",
                        className: "text-center font-bold text-indigo-500 max-sm:hidden",
                        children: item.subTitle
                    })
                ]
            })
        ]
    });
};
export default QuickMenu;
